<template>
<div class="chapter">
<div class="inner_page">
<a id="p0"></a>
<p class="center ">Copyright © 2001 by Diane Duane</p>
<p class="center spaceabove1">All rights reserved. No part of this publication may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopy, recording, or any information storage and retrieval system, without permission in writing from the publisher.</p>
<p class="center spaceabove1">For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<p class="center spaceabove1">
<a href="https://hmhbooks.com/" target="_blank">hmhbooks.com</a>
</p>
<p class="center spaceabove1">Originally published in hardcover in 2001 by Harcourt, Inc.</p>
<p class="center spaceabove1">The Library of Congress has cataloged the print edition as follows:</p>
<p class="center ">Duane, Diane.<br/>
The wizard’s dilemma/Diane Duane.<br/>
p. cm.—(The young wizards series; 5)<br/>
“Magic Carpet Books.”<br/>
Sequel to: A wizard abroad.</p>
<p class="center ">Summary: Teenage wizard Nita travels to other universes to find a cure for her mother, who has brain cancer.</p>
<p class="center ">[1. Wizards—Fiction. 2. Cancer—Fiction. 3. Fantasy.] I. Title.</p>
<p class="center ">PZ7.D84915Wk 2001<br/>
[Fic]—dc21 00-12998</p>
<p class="center spaceabove1">ISBN: 978-0-15-202460-4 paperback</p>
<p class="center spaceabove1">eISBN 978-0-547-54682-7<br/>
v4.0621</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?46ad389b